export enum Roles {
  SystemAdmin = 'SystemAdmin',
  ProgramAdmin = 'ProgramAdmin',
  AgentRestricted = 'AgentRestricted',
  AgentAll = 'AgentAll',
}
